export default "__VITE_ASSET__f9affa20__"